import { FormattedMessage, useIntl } from 'react-intl';

import { LinkButton } from '@atlaskit/button/new';
import Heading from '@atlaskit/heading';
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { AS_A_TEAM_URL } from '@/common/routes/constants';

import { BlueprintVector } from './assets';
import { messages } from './messages';

const boxStyles = xcss({
	borderRadius: 'radius.large',
	border: `1px solid ${token('color.border.disabled')}`,
});

export const UserNotProvisionedErrorDisplay = () => {
	const intl = useIntl();

	return (
		<Box padding="space.300" backgroundColor="elevation.surface.sunken" xcss={boxStyles}>
			<Inline space="space.400" alignBlock="center">
				<BlueprintVector alt={intl.formatMessage(messages.noEngagementGraphicAltText)} />

				<Stack space="space.200">
					<Heading size="small">
						<FormattedMessage {...messages.userAccountNotProvisionedHeading} />
					</Heading>
					<Text>
						<FormattedMessage {...messages.userAccountNotProvisionedDescription} />
					</Text>
					<Box>
						<LinkButton href={AS_A_TEAM_URL} target="_blank">
							<FormattedMessage {...messages.userAccountNotProvisionedButton} />
						</LinkButton>
					</Box>
				</Stack>
			</Inline>
		</Box>
	);
};
